import { render, staticRenderFns } from "./PaymentGroups.vue?vue&type=template&id=25d4b7ad&"
import script from "./PaymentGroups.vue?vue&type=script&lang=js&"
export * from "./PaymentGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports